var Forms = {
    /**
     * Bind custom image field actions
     */
    bindImageFields: function() {
        // Remove the existing image
        $('a.replace-image').on('click', function(e) {
            e.preventDefault();

            // Hide the existing image
            var $field = $('#' + $(this).data('image') + '_image');
            $field.next().removeClass('hidden-xs-up');
            $field.hide();

            // Set the field options to be removed on save
            $('#' + $(this).data('image') + '_options').val('remove');
        });

        // Darkroom
        $('a.edit-image').on('click', function(e) {
            e.preventDefault();
            Forms.darkroomInputName = $(this).data('image');
            Forms.darkroomURL = $(this).parents('form').attr('action') + '/uploadbase64';

            var dkrm = new Darkroom('#' + $(this).data('image') + '_image', {
                backgroundColor: '#ffffff',

                plugins: {
                    crop: {
                        quickCropKey: 67,
                    },
                    save: {
                        callback: function() {
                            this.darkroom.selfDestroy();
                            $.ajax({
                                type:'POST',
                                url: Forms.darkroomURL,
                                data: {
                                    '_token': $('input[name="_token"]').val(),
                                    'type': 'base64',
                                    'file': Forms.darkroomInputName,
                                    'data': dkrm.canvas.toDataURL()
                                },
                                dataType: 'text',
                            }).done(function() {
                            }).fail(function() {
                            });
                        }
                    }
                }
            });
        });
    },

    /**
     * Bind dropzone (drag and drop image uploader)
     */
    bindDropzones: function() {
        Dropzone.autoDiscover = false;
        $('div.dropzone').each(function(elem) {
           var dropzoneControl = $(this)[0].dropzone;
           if (dropzoneControl) {
               dropzoneControl.destroy();
           }
           Forms.bindDropzone($(this));
        });
    },

    bindDropzone: function(dz) {
        Forms.dropzoneInputName = dz.data('name');
        Forms.dropzoneAccept = dz.data('accept');
        var fieldName = dz.data('custom');
        var url = dz.parents('form').attr('action');
        var token = $('input[name="_token"]').val();
        var id = '';
        if (dz.data('id') !== undefined) {
            id = dz.data('id');
        }
        if (dz.data('url') !== undefined) {
            url = dz.data('url');
        }
        var multiple = true;
        if (dz.data('multiple') !== undefined) {
            multiple = dz.data('multiple');
        }
        dz.dropzone({
            init: function() {
                var that = this;
                $("button#clearStarCard, button#starCardCancel").click(function() {
                    //that.removeAllFiles(true);
                    that.on('sending uploadprogress', function() {
                        //that.removeAllFiles(true);
                        return false;
                    });
                    that.removeAllFiles(true);
                    console.log('Cancel - removing all uploading files');
                });
            },
            paramName: Forms.dropzoneInputName,
            dictDefaultMessage: '',
            url: url,
            previewTemplate: '<div class="dz-preview dz-file-preview" style="display: inline; margin-right: 10px;"><img data-dz-thumbnail /></div> <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div><div class="dz-error-message"><span data-dz-errormessage></span></div></div>',
            acceptedFiles: Forms.dropzoneAccept,
            headers: {
                'X-CSRF-Token': token,
            },
            /* ctel 20240604 increase upload filesize
            maxFilesize: 100,
            */
            maxFilesize: 1074,
            parallelUploads: 10000,
            uploadMultiple: multiple,
            timeout: 180000,

            // When the file starts sending, change the message to uploading
            sending: function (file, response, formData) {
                console.log(file);
                $('.dz-message').html('Uploading, please wait...');
                $('.image-controls').hide();
                $('div.dropzone .placeholder').html('');
                formData.append('_token', token);
                formData.append('custom_field_name', fieldName);
                formData.append('id', id);
                var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
                $('#starCardSave').html(html).attr('disabled', true);

                response.ontimeout = function() {
                    // Execute in case of timeout only
                    console.log('Server Timeout');
                }
            },

            // When a response is received, show the appropriate message
            success: function (file, response) {
                /* response = '' on success, file has the upload status
                console.log(response);
                response = JSON.parse(response);
                */
                console.log('file status = '+file.status);
                response = {success: file.status == 'success', error: file.status};
                $('div.dropzone .placeholder').html('');
                if (!response.success) {
                    $('.dz-message').html('There was an error uploading your file: ' + response.error + '. Please try again.<br>');
                } else {
                    /* The following code doesn't work
                    $('.dz-message').html('Processing, please wait...');
                    $('div.dropzone').hide();

                    // Add a cache breaker to the image to refresh it
                    var newImagePath = response.success + '?' + new Date().getTime();
                    $('img#' + Forms.dropzoneInputName + '_image').attr('src', newImagePath).removeClass('hidden-xs-up').show();
                    $('.image-controls').show();
                    */
                }
            },

            // When an error is received, show the message in the box
            error: function (file, error) {
                $('div.dropzone .placeholder').html('');
                $('.dz-message').html(error + ' Please try again.<br>');
            },

            // Update the percentage
            uploadprogress: function(file, progress, bytesSent) {
                var percentage = Math.round(progress);
                $('div.dropzone .placeholder').html('');

                //console.log('progress = '+progress+' bytesSent / file.size = '+bytesSent+'/'+file.size+' = '+bytesSent / file.size);

                if (percentage >= 100) {
                    $('.dz-message').html('Uploaded, now press save!<br>');
                    var html = '<i class="fa fa-check fa fa-file-o fa-lg"></i> Save';
                    $('#starCardSave').html(html).attr('disabled', false);
                } else {
                    $('.dz-message').html('Uploading (' + Math.round(progress) + '%), please wait...<br>');
                }
            },
        });
    }
};